import { computed } from 'vue';
import { useRoute } from 'vue-router';

export const useCurrentUrl = (basePath = null) => {
    const route = useRoute();

    const currentUrl = computed(() => {
        if (basePath) {
            return basePath;
        }

        // Auto-generate from route
        const pathSegments = route.path.split('/').filter(Boolean);
        return `/${pathSegments.join('/')}`;
    });

    return currentUrl;
};